<!--suppress JSBitwiseOperatorUsage -->
<ot-overlay-notification [data]="notificationData | async" (onClose)="closeNotify($event)"
                         [@flyInOut]="notificationData && (notificationData | async)"
                         *ngIf="notificationData && (notificationData | async)"></ot-overlay-notification>
